import {
  CustomerManagementDetail,
  CustomerManagementList,
  PassUserManagementDetail,
  PassUserManagementList,
  UserManagementDetail,
  UserManagementList,
} from "@admin/pages/account-management";
import type { RouteObject } from "react-router-dom";

const userRoutes = [
  { index: true, element: <UserManagementList /> },
  { path: ":id", element: <UserManagementDetail /> },
] satisfies RouteObject[];
const customerRoutes = [
  { index: true, element: <CustomerManagementList /> },
  { path: ":id", element: <CustomerManagementDetail /> },
] satisfies RouteObject[];
const passUserRoutes = [
  { index: true, element: <PassUserManagementList /> },
  { path: ":id", element: <PassUserManagementDetail /> },
] satisfies RouteObject[];
export const accountManagementRoutes = [
  { path: "/users", children: userRoutes },
  { path: "/customers", children: customerRoutes },
  { path: "/pass_users", children: passUserRoutes },
] satisfies RouteObject[];
